import React, { useState, useEffect, useRef } from "react";
import drop from "../../assets/svg/arrow-down.svg";
import apple from "../../assets/svg/apple.svg";
import android from "../../assets/svg/android.svg";

const DownloadApplication = ({ name, googlePlayStore, applePlayStore }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [hovered, setHovered] = useState(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  return (
    <div
      ref={popupRef}
      onClick={() => setShowPopup(!showPopup)}
      style={{
        backgroundColor: "#f8f8f8",
        padding: "0 16px",
        borderRadius: "12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        height: "36px",
        position: "relative",
      }}
    >
      <div
        style={{
          fontSize: "13px",
          fontWeight: "500",
          color: "#172B4D",
        }}
      >
        Download
      </div>
      <img
        src={drop}
        alt="drop"
        style={{
          width: "10px",
          transition: "transform 0.3s",
          transform: showPopup ? "rotate(180deg)" : "rotate(0deg)",
          filter: "invert(12%) sepia(45%) saturate(4236%) hue-rotate(203deg) brightness(92%) contrast(100%)",
        }}
      />
      {showPopup && (
        <div
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          style={{
            borderRadius: "24px",
            padding: "20px",
            backgroundColor: "#ffffff",
            width: "280px",
            position: "absolute",
            top: "calc(100% + 12px)",
            zIndex: 9999,
            right: "0",
            boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.15)",
            border: "1px solid #f0f0f0",
          }}
        >
          <div
            style={{
              fontWeight: "700",
              fontSize: "14px",
              color: "#172B4D",
            }}
          >
            Download {name} app for
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              gap: "32px",
            }}
          >
            <div
              onMouseEnter={() => setHovered("android")}
              onMouseLeave={() => setHovered(null)}
              onClick={() => window.open(googlePlayStore, "_blank", "noopener,noreferrer")}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                minWidth: "88px",
                alignItems: "center",
                cursor: "pointer",
                padding: "16px",
                borderRadius: "12px",
                backgroundColor: hovered === "android" ? "#eff6ff" : "#f7f8f9",
              }}
            >
              <img src={android} style={{ width: "22px" }} alt="android" />
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  color: hovered === "android" ? "#3B84E6" : "#172B4D",
                }}
              >
                Android
              </div>
            </div>

            <div
              onMouseEnter={() => setHovered("ios")}
              onMouseLeave={() => setHovered(null)}
              onClick={() => window.open(applePlayStore, "_blank", "noopener,noreferrer")}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                minWidth: "88px",
                alignItems: "center",
                cursor: "pointer",
                padding: "16px",
                borderRadius: "12px",
                backgroundColor: hovered === "ios" ? "#eff6ff" : "#f7f8f9",
              }}
            >
              <img src={apple} style={{ width: "22px" }} alt="apple" />
              <div
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  color: hovered === "ios" ? "#3B84E6" : "#172B4D",
                }}
              >
                IOS
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadApplication;
